"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const utils_1 = require("./utils");
function setCookie(name, value, seconds, domain) {
    let expires = '';
    if (seconds) {
        let date = new Date();
        date.setTime(date.getTime() + seconds * 1000); // Convert seconds to milliseconds
        expires = '; expires=' + date.toUTCString();
    }
    const cookieParts = [
        `${name}=${value}`,
        expires,
        '; path=/',
        '; Secure',
        '; SameSite=None',
    ];
    if (domain) {
        console.log(`setting cookie on ${domain}`);
        cookieParts.push(`; domain=.${domain}`);
    }
    document.cookie = cookieParts.join('');
}
function removeSubdomains(url) {
    const hostname = new URL(url).hostname;
    const domainPattern = /([^\.]+\.[^\.]+)$/;
    const match = hostname.match(domainPattern);
    return match ? match[0] : hostname;
}
function _getCSRFToken(url) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield fetch(`${url}/csrf/api/v1/token`);
            if (!response.ok) {
                throw new Error(`Failed to fetch CSRF token: Server responded with status ${response.status}`);
            }
            const data = yield response.json();
            return (data === null || data === void 0 ? void 0 : data.csrfToken) || null;
        }
        catch (error) {
            console.error('There was a problem with the fetch operation:', error);
            return null;
        }
    });
}
class HttpService {
    constructor() {
        this.token = localStorage.getItem('token');
        this.dmToken = localStorage.getItem('dm_token');
    }
    static init(IBL_API_CONFIG, GLOBAL_HANDLERS) {
        HttpService.url = IBL_API_CONFIG.IBL_API_PROXY_URL;
        IBL_API_CONFIG['IBL_AXD_URL'] = IBL_API_CONFIG['IBL_DM_URL'];
        HttpService.urlConfig = IBL_API_CONFIG;
        HttpService.globalHandlers = GLOBAL_HANDLERS;
    }
    _buildRequestObject(method, path, data, includeAuthorizationHeader, customUrlKey, requiresCSRFToken = false, successCb, errorCb) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = customUrlKey && HttpService.urlConfig[customUrlKey]
                ? HttpService.urlConfig[customUrlKey]
                : HttpService.url;
            const requestObject = {
                url: url + path,
                type: method,
                data: data,
                contentType: 'application/json; charset=utf-8',
                success: function (_data) {
                    (0, utils_1.cacheMechanism)(path, data, _data);
                    successCb && successCb(_data);
                },
                error: function (error) {
                    var _a;
                    let token = localStorage.getItem('token');
                    if (error.status === 401 && token && (0, utils_1.isTokenExpired)()) {
                        (_a = HttpService.globalHandlers) === null || _a === void 0 ? void 0 : _a.errors[401]();
                    }
                    errorCb && errorCb(error);
                },
            };
            if (['IBL_LMS_URL', 'IBL_CMS_URL'].includes(customUrlKey)) {
                requestObject['xhrFields'] = {
                    withCredentials: true,
                };
            }
            if (includeAuthorizationHeader) {
                let authorizationValue;
                if (customUrlKey === 'IBL_DM_URL') {
                    authorizationValue = `Token ${localStorage.getItem('dm_token')}`;
                }
                else if (customUrlKey === 'IBL_AXD_URL') {
                    authorizationValue = `Token ${localStorage.getItem('axd_token')}`;
                }
                else {
                    authorizationValue = `Bearer ${localStorage.getItem('token')}`;
                }
                requestObject.beforeSend = (xhr) => {
                    xhr.setRequestHeader('Authorization', authorizationValue);
                };
            }
            if (requiresCSRFToken) {
                const csrfToken = yield _getCSRFToken(url); // Async call for CSRF token
                if (csrfToken) {
                    setCookie('csrftoken', csrfToken, 10, removeSubdomains(url));
                }
            }
            return requestObject;
        });
    }
    sendRequest(method, path, data = null, includeAuthorizationHeader = true, customUrlKey, requiresCSRFToken = false, successCb, errorCb) {
        return __awaiter(this, void 0, void 0, function* () {
            const cachedData = (0, utils_1.cacheMechanism)(path, data);
            if (method === 'GET') {
                if (cachedData) {
                    successCb && successCb(cachedData);
                    return;
                }
            }
            try {
                const request = yield this._buildRequestObject(method, path, data, includeAuthorizationHeader, customUrlKey, requiresCSRFToken, successCb, errorCb);
                $.ajax(request);
            }
            catch (error) {
                console.error('Error constructing request:', error);
                errorCb && errorCb(error);
            }
        });
    }
    // Simplify the API calls by using `sendRequest`
    post(path, data, successCb, errorCb, includeAuthorizationHeader = true, customUrlKey, requiresCSRFToken = false) {
        this.sendRequest('POST', path, data, includeAuthorizationHeader, customUrlKey, requiresCSRFToken, successCb, errorCb);
    }
    patch(path, data, successCb, errorCb, includeAuthorizationHeader = true, customUrlKey, requiresCSRFToken = false) {
        this.sendRequest('PATCH', path, data, includeAuthorizationHeader, customUrlKey, requiresCSRFToken, successCb, errorCb);
    }
    get(path, data, successCb, errorCb, includeAuthorizationHeader = true, customUrlKey, requiresCSRFToken = false) {
        this.sendRequest('GET', path, data, includeAuthorizationHeader, customUrlKey, requiresCSRFToken, successCb, errorCb);
    }
}
exports.default = HttpService;
